import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ProfileKasirLayout from '../layouts/ProfilKasirLayout';

export const ProfileKasirPages = () => {
  const navigate = useNavigate();
  const { user, isError } = useSelector((state) => state.auth);

  useEffect(() => {
    if (isError) navigate('/', { replace: true });
  }, [isError, navigate]);

  return (
    <>
      <ProfileKasirLayout userUuid={user?.uuid} />
    </>
  );
};
